import routerOptions0 from "C:/Users/jackb/Documents/Development/secret-stats/node_modules/.pnpm/nuxt@3.10.3_@libsql+client@0.4.3_@types+node@20.11.25_better-sqlite3@9.2.2_drizzle-orm@0.29.5_op577wbuamuvdssveh6i7z4euy/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}